/**
 * Org-scoped React Query keys. Every domain query is namespaced by the active
 * org, so switching org changes the keys and swaps the dataset wholesale while
 * each org's cache is preserved independently. Demo-driven mutations and reset
 * target these keys to reflect changes live.
 */
import type { OrgId } from '@wand/shared';

export const orgKey = {
  /** Root for an org — invalidate to refetch everything for that tenant. */
  all: (org: OrgId) => ['org', org] as const,
  /** The org's dataset; screens select slices from this single query. */
  dataset: (org: OrgId) => ['org', org, 'dataset'] as const,
  /** Editable process docs (the canvas). */
  processDocs: (org: OrgId) => ['org', org, 'processDocs'] as const,
  processDoc: (org: OrgId, id: string) => ['org', org, 'processDoc', id] as const,
};
